// Mapbox access tokens for The Irrational Map
// You can generate tokens at: https://account.mapbox.com/access-tokens/
const mapboxAccessToken = "pk.eyJ1IjoiZWxpZXplci1hYmF0ZSIsImEiOiJjbWtiaGN0ZWUwNDR6M2NweDh3cmVnc2IwIn0.1R0PyMArRmn7wL-pp_1Sbg";
const secondaryToken = "pk.eyJ1IjoiZWxpZXplci1hYmF0ZSIsImEiOiJjbWtiaGN0ZWUwNDR6M2NweDh3cmVnc2IwIn0.1R0PyMArRmn7wL-pp_1Sbg";
export { mapboxAccessToken, secondaryToken };